import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SlidePanelComponent } from './slide-panel/slide-panel.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    PageHeaderComponent,
    SidebarComponent,
    SlidePanelComponent,
    DialogConfirmComponent,
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    PageHeaderComponent,
    SidebarComponent,
    SlidePanelComponent,
  ],
})
export class ComponentsModule {}
